<div *ngIf="!(isAIUploading$ | async)" fxLayout="column" class="w-100" fxLayoutAlign="start center" fxLayoutGap="1em">
    <ng-container *ngIf="!videoMedia">
        <div
            *ngIf="mvp2"
            class="radio-wrap"
            fxLayout.lt-md="column"
            fxLayoutAlign="start center"
            fxLayoutAlign.lt-md="center start"
            fxLayoutGap="30px"
        >
            <span class="radio-label">{{ radioLabel }}:</span>
            <mat-radio-group
                fxLayoutAlign="start center"
                fxLayoutGap="70px"
                fxLayoutGap.lt-sm="20px"
                [formControl]="videoTypeControl"
            >
                <mat-radio-button value="file">
                    <span>{{ uploaderBtnLabel }}</span>
                </mat-radio-button>
                <mat-radio-button value="link">
                    <span i18n>Video Link</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <ng-container *ngIf="videoTypeControl.value === 'file'">
            <div class="video-uploader" fxFlex="0 1 100%" fxLayout="column" fxLayoutAlign="center center">
                <button class="upload-btn" mat-raised-button (click)="addMedia()" color="primary">
                    {{ uploaderBtnLabel }}
                </button>

                <div class="progress-wrapper" *ngIf="progress$ | async; let progress">
                    <mat-progress-bar class="progress" mode="determinate" [value]="progress"></mat-progress-bar>
                    <span class="progress-value">{{ progress }}%</span>
                </div>
            </div>
        </ng-container>
        <mat-form-field *ngIf="videoTypeControl.value === 'link'" fxFlex="0 1 100%">
            <textarea
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="15"
                #input
                matInput
                type="url"
                placeholder="Link"
                i18n-placeholder
                [formControl]="linkControl"
            >
            </textarea>

            <button
                matTooltip="Open link in new tab"
                i18n-matTooltip
                type="button"
                *ngIf="Utils.isUrl(linkControl.value)"
                class="open-link"
                mat-icon-button
                matSuffix
                (click)="goToLink(linkControl.value)"
            >
                <mat-icon>open_in_new</mat-icon>
            </button>
        </mat-form-field>
    </ng-container>
    <div class="relative w-100" *ngIf="videoMedia">
        <ng-container *ngIf="videoTypeControl.value === 'file'">
            <app-media-view
                class="w-50"
                fxLayoutAlign="start center"
                fxFlex="0 0 100%"
                [media]="videoMedia"
                [displayName]="false"
                [hasHiddenCopyLink]="hasHiddenCopyLink"
                [hasHiddenDeleteMedia]="hasHiddenDeleteMedia"
                [promptStateKey]="mediaPromptStateKey"
                [canRetryPrompt]="false"
                [authUser]="authUser$ | async"
                [hasRemoveVideoPlayerOption]="true"
                (removeMedia)="clearMedia()"
            >
            </app-media-view>
            <button
                *ngIf="canRemoveMedia"
                class="remove-file"
                color="warn"
                type="button"
                fxFlex="0 1 auto"
                mat-icon-button
                matTooltip="Remove file"
                i18n-matTooltip
                (click)="clearMedia()"
            >
                <mat-icon class="md-24">delete_outline</mat-icon>
            </button>
        </ng-container>
        <ng-container *ngIf="videoTypeControl.value === 'link'">
            <mat-form-field class="w-100">
                <textarea
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="15"
                    #input
                    matInput
                    type="url"
                    placeholder="Link"
                    i18n-placeholder
                    [formControl]="linkControl"
                >
                </textarea>

                <button
                    matTooltip="Open link in new tab"
                    i18n-matTooltip
                    type="button"
                    *ngIf="Utils.isUrl(linkControl.value)"
                    class="open-link"
                    mat-icon-button
                    matSuffix
                    (click)="goToLink(linkControl.value)"
                >
                    <mat-icon>open_in_new</mat-icon>
                </button>
            </mat-form-field>
        </ng-container>
    </div>
</div>
<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" *ngIf="isAIUploading$ | async">
    <mat-icon class="ai-loading-icon">smart_toy</mat-icon>
    <span i18n>Creating video...</span>
</div>
<ng-container *ngIf="isCheckingLink" [ngTemplateOutlet]="smallLoading"></ng-container>
<ng-container *ngIf="Utils.isVideoUrl(linkControl.value) || directPlaybackMedia">
    <div class="w-100" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
        <app-media-view
            *ngIf="Utils.isVideoUrl(linkControl.value)"
            fxLayoutAlign="center center"
            fxFlex="0 0 40%"
            [media_id]="linkControl.value"
            [displayName]="false"
            [hasHiddenCopyLink]="hasHiddenCopyLink"
            [hasHiddenDeleteMedia]="hasHiddenDeleteMedia"
            [promptStateKey]="mediaPromptStateKey"
            [authUser]="authUser$ | async"
            (removeMedia)="clearMedia()"
        >
        </app-media-view>
        <app-media-view
            *ngIf="directPlaybackMedia"
            fxLayoutAlign="center center"
            fxFlex="0 0 40%"
            [media]="directPlaybackMedia"
            [displayName]="false"
            [hasHiddenCopyLink]="hasHiddenCopyLink"
            [hasHiddenDeleteMedia]="hasHiddenDeleteMedia"
            [promptStateKey]="mediaPromptStateKey"
            [authUser]="authUser$ | async"
            (removeMedia)="clearMedia()"
        >
        </app-media-view>
        <ng-container *ngIf="youTubeVideoInfo$ | async; let videoData; else: youTubeNoInfo">
            <div class="info-wrapper" fxLayout="column" fxLayoutGap="10px">
                <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span class="info-title" i18n>Video title: </span>
                    <span class="info">{{ videoData.title }}</span>
                </div>
                <div fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span class="info-title" i18n>Duration: </span>
                    <span class="info">{{ videoData.duration | formatIsoDuration }}</span>
                </div>
                <div fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span class="info-title" i18n>Source: </span>
                    <span class="info">Youtube</span>
                </div>
            </div>
        </ng-container>
    </div>
</ng-container>
<ng-template #youTubeNoInfo
    ><ng-container *ngIf="isLoadingVideoInfo" [ngTemplateOutlet]="smallLoading"></ng-container>
</ng-template>
<ng-template #smallLoading>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>
